import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Spin,
  message,
} from "antd";

import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { downloadFilterdExcel, fetchList } from "../Dashboard/utils/slice";

import { fetchEducationLevelsList } from "../../../store/CommonSlice";

import { useEffect, useState, useRef } from "react";
import { RootState } from "../../../store/app";
import { useNavigate } from "react-router-dom";
import { Form } from "antd";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import { validateFields } from "../../../config/Global";
import { dateFormats } from "./utils/constants";
import dayjs from "dayjs";
import CancelButton from "../../../components/Buttons/CancelButton";
import SaveButton from "../../../components/Buttons/SaveButton";
import { DashboardBreadcrumb } from "../../../config/BreadcrumbConfig";
import ToolBar from "../../../components/ToolBar";
import DashboardCharts from "./components/DashboardCharts";
import { CUSTOMER_ROLE } from "../../../config/Constant";
import { LoadingOutlined, SyncOutlined } from "@ant-design/icons";
import UserDetailsModal from "./components/UserDetailsModal";

const CustomerDashboard = () => {
  const dispatch = useAppDispatch();
  const userDetail = useAppSelector((state: RootState) => state.auth.userDetail);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [industryList, setIndustryList] = useState<any>([]);

  const [filterdData, setFilterdData] = useState({
    start_date: '',
    end_date: '',
    customerId: [userDetail.company_id],
    ageMin: '',
    ageMax: '',
    gender: '',
    career_categories: '',
    skill_categories: '',
    disabilities: '',
    experience_level: '',
    household: '',
    industryId: industryList.map((item: any) => item.id),
    careers: '',
    certifications: '',
  });
  const [graphModalObject, setGraphModalObject] = useState<any>(null);
  const [graphModal, setGraphModal] = useState(false);


  useEffect(() => {
    !graphModal && setGraphModalObject(null);
  }, [graphModal]);



  useEffect(() => {
    if (userDetail != null) {
      if (userDetail.role_id != CUSTOMER_ROLE) {
        navigate("/");
        return;
      }
      setIsLoaded(true);

      setIndustryList(userDetail?.company_industries || []);
      dispatch(fetchEducationLevelsList()).catch((error: any) => error);

      console.log("userDetail", userDetail);


    }
  }, [userDetail]);


  useEffect(() => {
    if (industryList.length > 0) {
      onReset()
    }
  }, [industryList]);


  const educationLevels: any = useAppSelector((state: RootState) => state.common.educationLevelsList);
  const userInterestAssessmentDetail: any = useAppSelector((state: RootState) => state.auth.initialData);

  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [showMoreFiltes, setShowMoreFiltes] = useState<any>(false);
  const [detailsObj, setDetailsObj] = useState<any>(null);
  const onValuesChange = () => {
    validateFields(form, setDisabled);
  };


  const [disabledRange, setDisabledRange] = useState(false);

  const onChangeRange = (checked: boolean) => {
    setDisabledRange(checked);
  };

  const onFinish = (graphFilter: any = null) => {
    let data = form.getFieldsValue()

    let error = 0;
    if (!data.start_date && data.end_date) {
      message.error('Please select start date');
      error++;
    }
    if (!data.end_date && data.start_date) {
      message.error('Please select end date');
      error++;
    }
    if (!data.ageMax && data.ageMin) {
      message.error('Please select max age');
      error++;
    }
    if (!data.ageMin && data.ageMax) {
      message.error('Please select min age');
      error++;
    }
    if (error > 0) {
      return 0;
    }
    setIsLoading(true)
    var requestData: any = {
      customerId: [userDetail.company_id],
      industryId: data?.industries && data.industries.length > 0 ? data.industries : industryList.map((item: any) => item.id),
      household: data?.house_hold_income || '',
      ageMin: data?.ageMin || '',
      ageMax: data?.ageMax || '',
      disabilities: data?.disability_status==0 ? 0 : (data?.disability_status || ''),
      start_date: '',
      end_date: '',
      career_categories: '',
      skill_categories: '',
      experience_level: '',
      gender: '',
      careers: '',
      certifications: '',
    }
    if (data.start_date && data.end_date) {
      requestData.start_date = dayjs(data.start_date).format('YYYY-MM-DD');
      requestData.end_date = dayjs(data.end_date).format('YYYY-MM-DD');
    }
    let filteredRecords: any = filterdData;
    if (graphFilter != null) {
      let objkey = graphFilter.graph_key;
      if (objkey == 'age_group') {
        const splitArray = graphFilter.graph_label_value.split('-');
        if (splitArray.length > 0)
          if (!filteredRecords?.ageMin && splitArray[0]) {
            requestData.ageMin = splitArray[0];
          }
        if (!filteredRecords?.ageMax && splitArray[1]) {
          requestData.ageMax = splitArray[1];
        }
      }
      else {
        let pass_value = detailsObj[objkey]?.find((element: any) => element.name == graphFilter.graph_label_value)?.id;
        if (objkey == 'zip_code') {
          pass_value = graphFilter.graph_label_value;
        }
        else if (objkey == 'certifications') {
          pass_value = detailsObj[objkey]?.find((element: any) => element.short_form == graphFilter.graph_label_value)?.id;
        }
        else if (objkey == 'career_categories' || objkey == 'skill_categories') {
          pass_value = detailsObj[objkey]?.find((element: any) => element.code == graphFilter.graph_label_value)?.id;
        }
        if (!filteredRecords[objkey] || filteredRecords[objkey] != pass_value) {
          requestData[objkey] = pass_value?.toString();
        }
      }
    }

    dispatch(fetchList(requestData)).then((response: any) => {
      console.log('response', response)
      setDetailsObj(response.data)
      setFilterdData(requestData)
      setIsLoading(false)
    }).catch((error: any) => error);

  };


  const onReset = () => {
    form.resetFields();
    setStartDate(null);
    setEndDate(null);
    setDisabled(true);

    const requestData = {
      start_date: '',
      end_date: '',
      customerId: [userDetail.company_id],
      ageMin: '',
      ageMax: '',
      gender: '',
      career_categories: '',
      skill_categories: '',
      disabilities: '',
      experience_level: '',
      household: '',
      industryId: industryList.map((item: any) => item.id),
      careers: '',
      certifications: '',
    }
    dispatch(fetchList(requestData))
      .then((response: any) => {
        console.log('response', response)
        setIsLoading(false)
        setFilterdData(requestData)
        setDetailsObj(response.data)
      }).catch((error: any) => error);
  };
  const disableDate = (current: any, type = "start", date: any = null) => {
    if (current > dayjs()) return true;
    if (date == null) {
      return false;
    }
    return current && (type == "start" ? current > dayjs(date) : current < dayjs(date));

  };

  const downloadExcel = (graphModalObject: any = null) => {
    let requestData = {
      ...filterdData,
      ...{ graph_type: '' },
    }
    if (graphModalObject) {
      requestData.graph_type = graphModalObject.graph_key;
    }
    setIsLoading(true)
    dispatch(downloadFilterdExcel(requestData))
      .then((response: any) => {
        setIsLoading(false)
        let url = response.data.url;
        const anchor: HTMLAnchorElement = document.createElement("a");
        anchor.href = url;
        anchor.download = 'dashboard_excel.xlsx';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }).catch((error: any) => error);
  }


  const FilterForm: any = <FormBox
    form={form}
    id={'filterForm'}
    onFinish={onFinish}
    onValuesChange={onValuesChange}
  >
    <Row gutter={[0, 0]}>
      <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 20 }}>
        <Row gutter={[15, 15]}>

          <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
            <InputBox.DatePicker
              style={{ marginBottom: 0 }}
              placeholder="Select Start Date"
              name="start_date"
              format={dateFormats.start_date}
              onChange={(date) => setStartDate(date)}
              disabledDate={(date) => disableDate(date, 'start', endDate)}

            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }} >
            <InputBox.DatePicker
              style={{ marginBottom: 0 }}
              placeholder="Select End Date"
              name="end_date"
              format={dateFormats.end_date}
              onChange={(date) => setEndDate(date)}
              disabledDate={(date) => disableDate(date, 'end', startDate)}
            />
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 12 }} >
            <InputBox.Checkbox
              onChange={(e: any) => setShowMoreFiltes(e.target.checked)}
            >More Filters</InputBox.Checkbox>

          </Col>
          {showMoreFiltes && <>
            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
              <InputBox.Select
                style={{ marginBottom: 0 }}
                mode="multiple"
                placeholder="Select Household Income"
                name="house_hold_income"
                showSearch
                className="multiSelect"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                options={{
                  list: userInterestAssessmentDetail?.annual_income,
                  valueKey: "id",
                  textKey: "name",
                }}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 4 }} >
              <InputBox.Select
                allowClear
                style={{ marginBottom: 0 }}
                placeholder="Select Disability Status"
                name="disability_status"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                options={{
                  list: userInterestAssessmentDetail?.disability_status,
                  valueKey: "id",
                  textKey: "name",
                }}
              />
            </Col>

            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 4 }}>

              <InputBox.Number
                max={100}
                min={10}
                name="ageMin"
                placeholder="Enter Min Age"
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 4 }}>

              <InputBox.Number
                max={100}
                min={10}
                name="ageMax"
                placeholder="Enter Max Age"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const ageMin = getFieldValue('ageMin');
                      if (!value || !ageMin || value >= ageMin) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Max age cannot be less than min age!'));
                    },
                  }),
                ]}
              />

            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }} >
              <InputBox.Select
                mode="multiple"
                placeholder="All Industries"
                name="industries"
                showSearch
                className="multiSelect"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                options={{
                  list: industryList,
                  valueKey: "id",
                  textKey: "industry_name",
                }}
              />
            </Col>
          </>}
        </Row>

      </Col>
      <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 4 }}>

        <Space align="end" >
          <CancelButton title="Reset" key={2} onClick={() => onReset()} />
          <SaveButton
            name="Apply"
            key={1}
            form="filterForm"
            disabled={disabled}
            loading={saving}
          />

        </Space>
      </Col>
    </Row>

  </FormBox>




  return (<>
    <div className="main-dashboard">
      <ToolBar breadcrumbs={DashboardBreadcrumb}>
        <Button className="cancelBtn rounded" onClick={() => downloadExcel()}>
          Export
        </Button>
      </ToolBar>
      <Row className="dashboard-filter-row" gutter={[15, 15]}>
        <Col xxl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
          <Space direction="vertical"
            style={{ width: '100%', textAlign: 'start', padding: 0 }}
          >
            <Card style={{ width: '100%', textAlign: 'start', padding: 0 }}>
              {FilterForm}
            </Card>
          </Space>
        </Col>
      </Row>
      <Spin spinning={isLoading} fullscreen delay={500} size="large" indicator={<LoadingOutlined style={{ color: 'white' }} spin />} />
      <DashboardCharts setGraphModalObject={setGraphModalObject} downloadExcel={downloadExcel} chart_js_data={detailsObj} getFormData={form.getFieldsValue} onGraphClick={onFinish} onReset={onReset} role="customer" />
      <UserDetailsModal graphModalObject={graphModalObject} setIsLoading={setIsLoading} filterdData={filterdData} graphModal={graphModal} setGraphModal={setGraphModal} />
    </div>
  </>);

};
export default CustomerDashboard;
